<template>
  <div class="tariff-slide">
    <div class="tariff-slide__content">
      <div class="tariff-slide__header" :style="{ backgroundColor: getTariffColor }">
        <span class="text-base-lidl uppercase">{{ tariff.name || '' }}</span>
        <span v-if="tariff.tariffId === CLASSIC_TARIFF_ID" class="text-2xl text-align-center"> Datenvolumen flexibel zubuchbar</span>
        <span v-else class="text-xl-lidl">{{ getVolumeDetail('INTERNET', 'amount') }} {{ getVolumeDetail('INTERNET', 'unit') }}</span>

        <span class="text-base-lidl" v-if="tariff.tariffId !== CLASSIC_TARIFF_ID">{{ getVolumeDetail('INTERNET', 'text') }}</span>
      </div>
      <div class="tariff-slide__body">
        <div v-if="tariff.activePromo" class="tariff-slide__special-offer">
          {{ tariff.promoText }}
        </div>
        <span class="text-xl-lidl" v-if="tariff.tariffId === CLASSIC_TARIFF_ID">{{convertToDecimal(getVolumeDetail('PHONE', 'amount'))}}</span>
        <span class="text-xl-lidl" v-else>
           {{ getVolumeDetail('PHONE', 'unit') === 'FLAT'
          ? getVolumeDetail('PHONE', 'unit')
          : getVolumeDetail('PHONE', 'amount')
          }}
          {{ getVolumeDetail('PHONE', 'unit') === 'CENT'
          ? 'Cent'
          : ''
          }}
        </span>
        <span v-if="tariff.tariffId === CLASSIC_TARIFF_ID" class="text-base-inter">
           pro Minute und SMS
        </span>
        <span class="text-base-inter" v-else>
           Minuten und SMS
        </span>
        <span v-if="tariff.tariffId === CLASSIC_TARIFF_ID" class="text-base text-align-center">
          Keine Mindestlaufzeit <br>
          Keine Grundgebühr <br>
          Zahle nur, was du nutzt
        </span>
        <span v-else class="text-xl-lidl text-price">
          {{ tariff.formattedBasicFee }}
        </span>
        <slot></slot>
      </div>
      <div class="tariff-slide__footer">
        <button class="button button--secondary full-width" @click="$emit('select-tariff')">
          Zum Tarif
          <img src="files/lidl/images/new-icons/svg/chevron-right-blue.svg" alt="">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const CLASSIC_TARIFF_ID = '82'
export default {
  data() {
    return {
      CLASSIC_TARIFF_ID
    }
  },
  name: 'TariffSlide',
  props: {
    tariff: {
      type: Object,
      required: true
    },
    specialOffer: {
      type: Boolean,
      default: false
    },
    specialOfferText: {
      type: String,
      default: 'Sonderaktion'
    }
  },
  computed: {
    getTariffColor() {
      return `var(--tariff-${this.tariff.tariffId}, var(--tariff-default))`
    },
    hasVolumeDetails() {
      return (
        this.tariff.volumeDetails &&
        (Array.isArray(this.tariff.volumeDetails)
          ? this.tariff.volumeDetails.length > 0
          : Object.keys(this.tariff.volumeDetails).length > 0)
      )
    }
  },
  methods: {
    getTariffDetail(category, type) {
      return this.tariff?.tariffExtra?.details?.[category]?.[type] || ''
    },
    getVolumeDetail(type, key) {
      if (!this.tariff.volumeDetails) {
        return null
      }
      const list = Array.isArray(this.tariff.volumeDetails)
        ? this.tariff.volumeDetails
        : [this.tariff.volumeDetails]

      const found = list.find(item => item.type === type)
      return found && key in found ? found[key] : null
    },
    convertToDecimal(value) {
      return value / 100 + '€'
    }
  }
}
</script>
